/** Bonus Issue 콤보 옵션 — CDD(cddOptions) 재사용. (OTC otcOptions 미러링.) */
import { comboOptions as cddComboOptions, type ComboOpt } from '../cdd/cddOptions';
import type { BonusComboSource } from './bonusFields';

export type { ComboOpt } from '../cdd/cddOptions';
export { resolveNationality, resolveCountryOption, resolveOccupation } from '../cdd/cddOptions';

export function comboOptions(src: BonusComboSource | null): ComboOpt[] {
  if (!src) return [];
  return cddComboOptions(src);
}
